import {
    compose,
    branch,
    renderNothing,
    renderComponent,
    setDisplayName,
} from 'react-recompose';
import { withRouter } from 'react-router-dom';
import * as s from '~/state/ducks/app/selectors.js';
import app from '~/state/ducks/app/actions.js';
import withReduxConnect from '~/views/enhancers/withReduxConnect.js';

import SearchResults, { NoResultsFound } from '../components/SearchResults.jsx';

export default compose(
    setDisplayName('SearchResultsContainer'),
    withReduxConnect({
        mapStateToProps: state => ({
            numResults: s.getNumResults(state),
            numPerPage: s.getNumPerPage(state),
            numPages: s.getNumPages(state),
            activePage: s.getActivePage(state),
            pageData: s.getActivePageData(state),
            shouldShowResults: s.showResults(state),
            sortByField: s.getSortByField(state),
            isSortReverse: s.getIsSortReverse(state),
            selectedItems: s.getSelectedAffiliates(state),
        }),
        mapDispatchToProps: {
            handlePerPageChange: app.search.itemsPerPage.set,
            handlePageChange: app.search.activePage.set,
            handleSortChange: app.search.sortBy.set,
            setItemSelected: app.affiliateSelector.selectedItems.set,
        },
    }),
    withRouter,
    branch(({ shouldShowResults }) => !shouldShowResults, renderNothing),
    branch(({ numResults }) => numResults <= 0, renderComponent(NoResultsFound)),
)(SearchResults);
